const n="\n    id\n    firstName\n    lastName\n    displayName\n    createdAt\n    updatedAt\n    acceptsMarketing\n    email\n    phone\n    tags\n    numberOfOrders\n";export{n as CUSTOMER_FIELDS};
//# sourceMappingURL=customer.js.map
